import axios, { AxiosInstance } from 'axios';
import { getCloverApiHostname } from 'utils/Environment';

export const CLIENT_PATHS = ['checkout', 'pay-widgets'];

export const HOSTNAME = getCloverApiHostname();
export const SERVER_PATH = 'invoicingcheckoutservice/v1';

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: `${HOSTNAME}/${SERVER_PATH}`
});
